import React, { useMemo } from 'react';
import times from 'lodash/times';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { LoadingSkeleton } from '@atlassian/help-center-common-component/loading';
import { SectionResultContainer, ResultItemContainer, LinkContainer, ResultTitleContainer } from '../common';

export const SearchResultsLoader = () => {
    const linkContainer = useMemo(() => {
        return times(2, (index) => (
            <LinkContainer key={index} actionSubjectId="loading-link-container">
                <ResultItemContainer>
                    <LoadingSkeleton height={60} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
                </ResultItemContainer>
            </LinkContainer>
        ));
    }, []);

    return (
        <SectionResultContainer>
            <ResultTitleContainer>
                <LoadingSkeleton height={30} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
            </ResultTitleContainer>
            {linkContainer}
            <ResultTitleContainer>
                <LoadingSkeleton height={30} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
            </ResultTitleContainer>
            {linkContainer}
            <ResultTitleContainer>
                <LoadingSkeleton height={30} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
            </ResultTitleContainer>
            {linkContainer}
        </SectionResultContainer>
    );
};
